import Logo from "./components/Logo/Logo";
import ObjectStatus from "./components/ObjectStatus/ObjectStatus";

function TopBar() {

    return (
        <div>
            <Logo />
            <ObjectStatus />
        </div>
    )
}

export default TopBar